/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_SendInputs */



/**
* | output |
* | --- |
* | "Send" |
*
* @param {Assistant_SendInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_send = /** @type {((inputs?: Assistant_SendInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_SendInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Envoyer")
	if (locale === "de") return /** @type {LocalizedString} */ ("Schicken")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inviare")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Отправлять")
	if (locale === "es") return /** @type {LocalizedString} */ ("Enviar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("发送")
	if (locale === "ja") return /** @type {LocalizedString} */ ("送信")
	if (locale === "hi") return /** @type {LocalizedString} */ ("भेजना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Enviar")
	return /** @type {LocalizedString} */ ("Send")
});